import { createContext } from "react";
import { Titration } from "src/api/types";
import { usePrescription } from "../PrescriptionProvider";
import { useGetPatientTitrationForProductQuery } from "src/api/services/titrationApi";

export const TitrationContext = createContext<Titration | undefined>(undefined);

interface Props {
  children: React.ReactNode;
}

const TitrationProvider = ({ children }: Props) => {
  const slug = usePrescription((p) => p.product.slug);
  const patientId = usePrescription((p) => p.patient_id);
  const { data: titration, isLoading } = useGetPatientTitrationForProductQuery({
    slug,
    patient_id: patientId,
  });

  if (isLoading) {
    return null;
  }

  return (
    <TitrationContext.Provider value={titration}>
      {children}
    </TitrationContext.Provider>
  );
};

export default TitrationProvider;
